<template>
    <div class="container">
<!-- <h2>Tipo de Equipos</h2>
<v-divider></v-divider> -->
        
            <v-card>
                <v-card-title class="titulopagina">ADMINISTRAR TIPOS DE MATERIA PRIMA</v-card-title>
                <v-card-text>
                    <v-btn color="green" fab small dark @click="crear">
                         <v-icon>add</v-icon>
                    </v-btn>
                </v-card-text>
                <!-- <Tabla :ajustes="this.ajustes" @editar="editar($event)"></Tabla> -->
            </v-card>
            
            <data-table class="mt-5" @editar="editar($event)"></data-table>

            <modal @peticionrealizada="cargarDatos"></modal>
    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex'
import Tabla from '@/components/shared/Tabla.vue'
import Data_Table from '@/components/shared/Data_Table.vue'
import Modal from '@/components/shared/Modal.vue'
// import axios from 'axios'
export default {
    data:()=>({
        ajustes:{
            columnas:[
                {key:'tipo_materia_prima',titulo:'Tipo de Materia Prima',visible:true,filtro:{visible:true,orden:'ASC'},path:'tipo_materia_prima',tipo:'texto'}
            ],
            acciones:[
                {key:'editar',titulo:'Editar',visible:true}
            ]
        },
        lista:[],
        tipo_configuraciones_mp:[],
        inputs:[
            {tipo:'texto',valor:'',label:'Materia Prima*',key:'tipo_materia_prima'},
            {tipo:'select',valor:'',label:'Seleccione Configuración MP*',key:'configuracion_mps_id',opciones:[{id:1, usar_en:"Análisis"},{id:2, usar_en:"Producción"},{id:3, usar_en:"Lotes"}],texto:'usar_en',seleccion:'id'},
            {tipo:'texto',valor:'',label:'Codigo',key:'codigo'},
        ],
        configuracion_modal:{
            titulo_modal:'',
            boton_submit:'',
            ruta:'',
            tipo_peticion:''
        },

        //configuracion para datatable
        cabeceras:[
                {
                    text:'Id',
                    align:'center',
                    sortable:true,
                    filterable:true,
                    value:'id',
                    class:'cabecera'
                },
                {
                    text: 'Usar en',
                    align:'center',
                    sortable: false,
                    value: 'configuraciones_mps[0].usar_en',
                    class:'cabecera'
                },
                {
                    text: 'Código',
                    align: 'center',
                    sortable: true,
                    value: 'codigo',
                    class:'cabecera'
                },
                {
                    text: 'Tipo de Materia Prima',
                    align: 'left',
                    sortable: true,
                    value: 'tipo_materia_prima',
                    class:'cabecera'
                },
                { text: 'Acciones', value: 'action', sortable: false, align:'center', class:'cabecera' },
        ],
        acciones:[
                {key:'editar',titulo:'Editar',visible:true}
        ]
    }),
    created() {
        // Event.$on('peticion_realizada',()=>{
        //     this.cargarDatos()
        // })
    },
    mounted() {
        this.cargarConfiguracionesMp();
    },
    methods: {
        async cargarConfiguracionesMp(){
            //this.mostrarLoading('Cargando Configuración Tipo de Mp');
            this.mostrarLoading({titulo:'Cargando Configuración Tipo de Mp...',color:'green'})

            let url = `${this.base_url}configuracion_mp`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('configuracion tipo mps',response.data.data[0].usar_en);
                this.tipo_configuraciones_mp = response.data.data;
                this.inputs[1].opciones = this.tipo_configuraciones_mp;
                this.cargarDatos();
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            })

        },
        async cargarDatos(){
            //console.log('hola');
            //this.mostrarLoading('Cargando Datos...');
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})

            let url = `${this.base_url}tipo_mps`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('respuesta',response);
                this.lista = response.data.data;
                // response.data.data.forEach(item => {
                //     this.lista.push({id:item.id,tipo_equipo:item.tipo_equipo})
                // });
                Event.$emit('actualizar_lista',this.lista);
                Event.$emit('llenar_tabla',this.lista,this.cabeceras,this.acciones);
                Event.$emit('inicializar_tabla',this.cabeceras,this.lista,this.acciones);
                this.ocultarLoading();
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            })
        },
        crear(){
            console.log('crear');
            this.configuracion_modal.titulo_modal = 'Crear Tipo de Materia Prima';
            this.configuracion_modal.boton_submit = 'Crear';
            this.configuracion_modal.ruta = 'tipo_mps';
            this.configuracion_modal.tipo_peticion = 'POST';
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },
        async editar($event){
            console.log('editando',$event);
            //por cada input se realiza el seteo correspondiente del item que se esta editando
            this.inputs.forEach(input => {
                //recorrido del objeto a editar
                Object.keys($event).forEach(key => {
                    let valor = $event[key];
                    if(input.key == key){
                        input.valor = valor;
                    }
                });
            });
            let configuracion_mp = await this.$buscarObjeto($event['configuracion_mps_id'],this.tipo_configuraciones_mp);
            this.inputs[1].valor = configuracion_mp;
            this.configuracion_modal.titulo_modal = 'Editar Tipo de Materia Prima';
            this.configuracion_modal.boton_submit = 'Actualizar';
            this.configuracion_modal.ruta = `tipo_mps/${$event.id}`;
            this.configuracion_modal.tipo_peticion = 'PUT';
            this.$emit('abrir',this.inputs,this.configuracion_modal);
            console.log('inputs',this.inputs);
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
    components:{
        Tabla,
        'modal':Modal,
        'data-table':Data_Table
    }
}
</script>